import Catalog from '@/creditflowresearch/ui/components/staticPages/Catalog';
import getServerSideIssuersCatalog
  from '@/creditflowresearch/application/Catalog/Issuers/serverSide/getServerSideIssuersCatalog';
import { CatalogIssuersProvider } from '@/creditflowresearch/application/Catalog/Issuers/IssuersCatalogContext';
import ICatalogCollection from '@/creditflowresearch/application/Catalog/common';
import withApplicationPropsV2 from '@/creditflowresearch/application/withApplicationPropsV2';

export const getServerSideProps = withApplicationPropsV2(async (context) => {
  const serverIssuersCatalog: ICatalogCollection = await getServerSideIssuersCatalog(context);
  return {
    props: {
      serverIssuersCatalog,
    },
  };
}, { needsLegacyDictionaries: false });

const ListOfGlobalFixedIncomeIssuers = ({ serverIssuersCatalog }: ICatalogCollection) => (
  <CatalogIssuersProvider issuers={ serverIssuersCatalog }>
    <Catalog />
  </CatalogIssuersProvider>
);

export default ListOfGlobalFixedIncomeIssuers;
